import { render, staticRenderFns } from "./AutoInvestCreate.vue?vue&type=template&id=5240eee3&"
import script from "./AutoInvestCreate.vue?vue&type=script&lang=js&"
export * from "./AutoInvestCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports